<template>
  <div class="chat-widget__messages">
    <div v-for="message in chatStore.getAllMessages" :key="message.id"
         :class="['chat-widget__message', { 'chat-widget__message--user': [MESSAGE_TYPE_USER, MESSAGE_TYPE_SYSTEM].includes(message.type), 'chat-widget__message-draft': message.type === MESSAGE_TYPE_DRAFT }]">
      <DraftMessage :message="message" v-if="message.type === MESSAGE_TYPE_DRAFT" />
      <ErrorMessage :message="message" v-else-if="message.type === MESSAGE_TYPE_ERROR" />
      <BatchMessage :message="message" v-else-if="message.type === MESSAGE_TYPE_BATCH_PROGRESS" />
      <ChatMessage :message="message" v-else />
    </div>
  </div>
</template>
<script setup>
import { useChatStore } from '@/modules/chat/stores/chatStore';
import {
  MESSAGE_TYPE_BATCH_PROGRESS,
  MESSAGE_TYPE_DRAFT,
  MESSAGE_TYPE_ERROR,
  MESSAGE_TYPE_SYSTEM,
  MESSAGE_TYPE_USER,
} from "@/constants";
import DraftMessage from "@/modules/chat/components/message/DraftMessage.vue";
import ErrorMessage from "@/modules/chat/components/message/ErrorMessage.vue";
import ChatMessage from '@/modules/chat/components/message/ChatMessage.vue';
import BatchMessage from "@/modules/chat/components/message/BatchMessage.vue";

const chatStore = useChatStore();
</script>